/**
 * Pure login-security helpers (no DOM / axios). Used by the React login
 * client and by ``loginSecurity.selfcheck.js``.
 */

export const DEVICE_STORAGE_KEY = 'user_device_id';

export function randomDeviceId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  const bytes = new Uint8Array(16);
  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < bytes.length; i += 1) {
      bytes[i] = Math.floor(Math.random() * 256);
    }
  }
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

/**
 * Retry ``POST /token/`` only when session login never reached Django auth
 * (missing endpoint, CSRF, or a network failure). 401/429 from /login/
 * must surface as-is — a second POST doubles IP rate-limit counters and
 * replaces a real /login/ error with a misleading /token/ 429.
 */
export function shouldFallbackToJwtLogin(error) {
  const status = error && error.response && error.response.status;
  if (!status) return true;
  return status === 403 || status === 404 || status === 405;
}
